<template>
  <section id="services" class="services">
    <div class="background" />
    <div class="header-box">
        <h2>Leistungen</h2>
    </div>
    <b-container cols="*">
      <b-row>
        <b-col>
          <b-card
              title="Wasserelemente"
              img-src="../../assets/images/wasser.svg"
              img-alt="Wasserelemente"
              img-top>
          </b-card>
        </b-col>
        <b-col>
          <b-card
              title="Pflanzen"
              img-src="../../assets/images/pflanzen.svg"
              img-alt="Pflanzen"
              img-top>
          </b-card>
        </b-col>
        <b-col>
          <b-card
              title="Pflege"
              img-src="../../assets/images/pflege.svg"
              img-alt="Pflege"
              img-top>
          </b-card>
        </b-col>
        <b-col>
          <b-card
              title="Terassenbau"
              img-src="../../assets/images/terassenbau.svg"
              img-alt="Terassenbau"
              img-top>
          </b-card>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-card
              title="Winterdienst"
              img-src="../../assets/images/winterdienst.svg"
              img-alt="Winterdienst"
              img-top>
          </b-card>
        </b-col>
        <b-col>
          <b-card
              title="Baumfällung"
              img-src="../../assets/images/baumfaellung.svg"
              img-alt="Baumfällung"
              img-top>
          </b-card>
        </b-col>
        <b-col>
          <b-card
              title="Sturmschäden"
              img-src="../../assets/images/sturmschaeden.svg"
              img-alt="Sturmschäden"
              img-top>
          </b-card>
        </b-col>
        <b-col>
          <b-card
              title="Mähen"
              img-src="../../assets/images/maehen.svg"
              img-alt="Mähen"
              img-top>
          </b-card>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-card
              title="Kehren"
              img-src="../../assets/images/kehren.svg"
              img-alt="Kehren"
              img-top>
          </b-card>
        </b-col>
        <b-col>
          <b-card
              title="Baggerarbeiten"
              img-src="../../assets/images/baggerarbeiten.svg"
              img-alt="Baggerarbeiten"
              img-top>
          </b-card>
        </b-col>
        <b-col>
          <b-card
              title="Plattenverlegung"
              img-src="../../assets/images/plattenverlegung.svg"
              img-alt="Plattenverlegung"
              img-top>
          </b-card>
        </b-col>
        <b-col>
          <b-img class="slogan" src="../../assets/images/services-slogan.png" />
        </b-col>
      </b-row>
    </b-container>
  </section>
</template>

<script>
  export default {
    name: 'Services',
  }
</script>

<style lang="scss">
  @import '../../assets/styles/home/services.scss';
</style>
